export const routeConfig = {
  meta: {
    active: '3',
  },
  params: ':id',
};
